export const deviceMotionFunction = (event) => {
    return {
        strong: Math.floor(Math.abs(event.acceleration.x * 2) + Math.abs(event.acceleration.y * 2)),
        lastNumR: event.acceleration.x + event.acceleration.y
    };
};

export const deviceOrientationFunction = (event) => {
    return {
        strong: Math.floor(Math.abs(event.beta) + Math.abs(event.gamma)),
        lastNumR: event.beta + event.gamma
    };
};
